import { Col, Row, Typography } from "antd";
import { BiUserCircle } from "react-icons/bi";
import { HiOutlineMenu } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import React, { ReactNode, useState } from "react";
import { CaretDownOutlined } from "@ant-design/icons";
import { Logo } from "../Logo";
import Button from "../Button";
import { items } from "./items";
import { isMobile } from "../../utils";
import { useAuth } from "../../contexts/AuthContext";
import { LayoutHeader, Title, User } from "./styles";
import { useSideBar } from "../../contexts/SideBarContext";

interface IHeaderProps {
  id: string;
  icon: string;
  title: ReactNode;
}

const Header: React.FC<IHeaderProps> = ({ id, title = "IRPF 2022", icon }) => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { setShowDrawer } = useSideBar();
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  const handleNav = (name: string) => {
    if (name === "Minha conta") {
      navigate("/conta");
    } else if (name === "Regulação") {
      navigate("/regulacao");
    } else if (name === "Sair") {
      signOut();
    }
  };

  return (
    <>
      <LayoutHeader>
        {isMobile() && (
          <Row align="middle" gutter={[16, 16]}>
            <Col>
              <span id="menu-button">
                <Button
                  size="large"
                  type="primary"
                  icon={<HiOutlineMenu />}
                  style={{ zIndex: 1 }}
                  onClick={() => setShowDrawer(true)}
                />
              </span>
            </Col>
            <Col>
              <Logo />
            </Col>
          </Row>
        )}

        {!isMobile() && (
          <span id="span-title">
            <Title level={1}>{title}</Title>
          </span>
        )}

        {user.user && (
          <User
            className={`${showUserDropdown ? "hover" : ""}`}
            onClick={() => setShowUserDropdown((show) => !show)}
          >
            <CaretDownOutlined />
            <BiUserCircle size={32} color="var(--ant-primary-color)" />
            {!isMobile() && (
              <Typography>
                Bem-vindo,
                <strong>
                  {user.user.name
                    .toLowerCase()
                    .split(" ")
                    .slice(0, 2)
                    .join(" ")}
                </strong>
              </Typography>
            )}
            <nav>
              <ul>
                {items.map((item) => (
                  <li
                    key={item.name}
                    className={item.className}
                    onClick={(event) => {
                      event.stopPropagation();
                      setShowUserDropdown(false);
                      handleNav(item.name);
                    }}
                  >
                    {item.icon} {item.name}
                  </li>
                ))}
              </ul>
            </nav>
          </User>
        )}
      </LayoutHeader>
    </>
  );
};

export default Header;
